import {
  Box,
  Button,
  FormHelperText,
  Paper,
  TextField,
  useTheme,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Headers from "../../components/Headers";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useState } from "react";
import FormControl from "@mui/material/FormControl";
import { useUserStore, useLoginStore } from "../../Utils/Store";
import * as yup from "yup";
import { Formik } from "formik";
import { tokens } from "../../theme";

const Form = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const registerUser = useUserStore((state) => state.registerUser);
  const isLogin = useLoginStore((state) => state.isLogin);

  const { access_level } = isLogin;

  const initialValues = {
    firstname: "",
    lastname: "",
    department: "",
    username: "",
    password: "",
    accessLevel: "",
  };

  const checkoutSchema = yup.object().shape({
    firstname: yup.string().required("required"),
    lastname: yup.string().required("required"),
    department: yup.string().required("required"),
    username: yup.string().required("required"),
    password: yup.string().required("required"),
    accessLevel: yup.string().required("required"),
  });

  return (
    <Box m="20px">
      <Paper
        elevation={0}
        sx={{ borderRadius: "10px", background: colors.primary[400] }}
      >
        <Headers title="Add User" />
      </Paper>
      <Paper
        elevation={0}
        sx={{
          borderRadius: "10px",
          padding: "10px",
          background: colors.primary[400],
        }}
      >
        <Formik
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            let payload = {
              firstname: values.firstname,
              lastname: values.lastname,
              department: values.department,
              username: values.username,
              password: values.password,
              access_level: values.accessLevel,
            };

            await registerUser(payload);
            setSubmitting(false);
            alert("User added successfully!");
            resetForm();
          }}
          initialValues={initialValues}
          validationSchema={checkoutSchema}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              >
                <TextField
                  fullWidth
                  type="text"
                  label="First Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.firstname}
                  name="firstname"
                  error={!!touched.firstname && !!errors.firstname}
                  helperText={touched.firstname && errors.firstname}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  type="text"
                  label="Last Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.lastname}
                  name="lastname"
                  error={!!touched.lastname && !!errors.lastname}
                  helperText={touched.lastname && errors.lastname}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  type="text"
                  label="Department"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.department}
                  name="department"
                  error={!!touched.department && !!errors.department}
                  helperText={touched.department && errors.department}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  type="text"
                  label="Username"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.username}
                  name="username"
                  error={!!touched.username && !!errors.username}
                  helperText={touched.username && errors.username}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  type="password"
                  label="Password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.password}
                  name="password"
                  error={!!touched.password && !!errors.password}
                  helperText={touched.password && errors.password}
                  sx={{ gridColumn: "span 2" }}
                />
                <FormControl
                  error={!!touched.accessLevel && !!errors.accessLevel}
                >
                  <InputLabel id="key">Access Level</InputLabel>
                  {access_level === "Manager" ? (
                    <Select
                      labelId="key"
                      id="key"
                      label="Access Level"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.accessLevel}
                      name="accessLevel"
                    >
                      <MenuItem value="Manager">Manager</MenuItem>
                      <MenuItem value="User">User</MenuItem>
                    </Select>
                  ) : (
                    <Select
                      labelId="key"
                      id="key"
                      label="Access Level"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.accessLevel}
                      name="accessLevel"
                    >
                      <MenuItem value="Admin">Admin</MenuItem>
                      <MenuItem value="Manager">Manager</MenuItem>
                      <MenuItem value="User">User</MenuItem>
                    </Select>
                  )}
                  <FormHelperText>
                    {touched.accessLevel && errors.accessLevel}
                  </FormHelperText>
                </FormControl>
              </Box>
              <Box display="flex" justifyContent="end" mt="20px">
                <Button
                  type="submit"
                  color="secondary"
                  variant="contained"
                  disabled={isSubmitting}
                >
                  Create New User
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Paper>
    </Box>
  );
};

export default Form;
